export default "__VITE_ASSET__Db0HC$1w__"